import { useEffect } from 'react';
import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import { ChartLine } from 'lucide-react';
import { PagePath } from '@/routes/paths';
import useStore from '@/stores/sider-menu';
import useReportBadgeStore from '@/features/reports/store/report-badge-store';
import MenuIcon from '@/layouts/main-layout/components/menu-icon';
import MenuItem from '@/layouts/main-layout/components/menu-item';
import { isLoggedIn } from '@/utils/auth';

function Badge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="min-w-[18px] h-[18px] rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center px-1 leading-none">
      {count > 99 ? '99+' : count}
    </span>
  );
}

export default function ReportsNav() {
  const { collapsed } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = !!matchPath(PagePath.reports, location.pathname);
  const { badgeCount, fetchBadgeCount } = useReportBadgeStore();

  useEffect(() => {
    if (isLoggedIn()) {
      fetchBadgeCount();
    }
  }, [fetchBadgeCount]);

  const handleClick = () => navigate(PagePath.reports);

  if (collapsed) {
    return (
      <MenuIcon onClick={handleClick} title="Reports" className="relative" isActive={isActive}>
        <ChartLine size={16} color="#737373" />
        {badgeCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[14px] h-[14px] rounded-full bg-red-500 text-white text-[8px] flex items-center justify-center px-0.5 leading-none">
            {badgeCount > 99 ? '99+' : badgeCount}
          </span>
        )}
      </MenuIcon>
    );
  }

  return (
    <MenuItem
      className={isActive ? 'bg-[#E5E5E5]/65' : ''}
      onClick={handleClick}
      icon={<ChartLine size={16} color="#737373" />}
      append={<Badge count={badgeCount} />}
    >
      Reports
    </MenuItem>
  );
}
